import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiGetScheduleDetails } from 'services/ScheduleService'
import { apiValidateSpecificSlotCoupon } from '../../services/AuthService'

export const fetchAppointmentDetails = createAsyncThunk(
    'appointment/fetchAppointmentDetails',
    async ({ userID, date, appliedCouponId }, thunkAPI) => {
        try {
            const { data } = await apiGetScheduleDetails(date, userID, appliedCouponId)
            return data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data)
        }
    }
)

export const validateSpecificSlotCoupon = createAsyncThunk(
    'coupon/validateSpecificSlotCoupon',
    async ({ payload }, thunkAPI) => {
        try {
            const response = await apiValidateSpecificSlotCoupon(payload)
            const { data } = response
            return data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data)
        }
    }
)

export const appointment = createSlice({
    name: 'appointment',
    initialState: {
        loading: false,
        selectedAppointment: null,
        slotType: null,
        appliedCouponCode: null,
        selectedAppointmentDate: null,
        isValidateCoupons: true,
        error: null,
    },
    reducers: {
        setSelectedAppointmentDate: (state, action) => {
            state.selectedAppointmentDate = action.payload
        },

        // setCouponCode: (state, action) => {
        //     state.appliedCouponCode = action.payload
        // },

        setSlotType: (state, action) => {
            state.slotType = action.payload
        },

        setIsValidateCoupon: (state, action) => {
            state.isValidateCoupons = action.payload
        },
        resetSelectedAppointment: (state) => {
            state.selectedAppointment = null
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAppointmentDetails.pending, (state) => {
                state.loading = true
            })
            .addCase(fetchAppointmentDetails.fulfilled, (state, action) => {
                state.loading = false
                state.selectedAppointment = action.payload
                state.error = null
            })
            .addCase(fetchAppointmentDetails.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })

        builder
            .addCase(validateSpecificSlotCoupon.pending, (state) => {
                state.loading = true
            })
            .addCase(validateSpecificSlotCoupon.fulfilled, (state, action) => {
                const { exists } = action.payload
                state.isValidateCoupons = exists
                state.loading = false
            })
            .addCase(validateSpecificSlotCoupon.rejected, (state, action) => {
                state.loading = false
                state.isValidateCoupons=false
            })
    },
})

export const {
    setSelectedAppointmentDate,
    setSlotType,
    setCouponCode,
    setIsValidateCoupon,
    resetSelectedAppointment
} = appointment.actions

export default appointment.reducer
